import moment from "moment";

const formatOS = (name) => {
    if (name.includes('mac') || name.includes('darwin')) {
        return 'MacOS'
    } else if (name.includes('win')) {
        return 'Windows'
    } else if (name.includes('android')) {
        return 'Android'
    } else if (name.includes('ios')) {
        return 'iOS'
    }

    return 'Unknown'
}

const iconOS = (name) => {
    if (name.includes('mac') || name.includes('darwin')) {
        return `<svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M3.33552 0H30.4812C32.1401 0 33.4974 1.35 33.4974 3V21C33.4974 22.65 32.1401 24 30.4812 24H19.9246L22.9408 28.5V30H10.876V28.5L13.8922 24H3.33552C1.67662 24 0.319336 22.65 0.319336 21V3C0.319336 1.35 1.67662 0 3.33552 0ZM3.33552 18H30.4812V3H3.33552V18Z"
                      fill="black" />
              </svg>`
    } else if (name.includes('win')) {
        return `<svg width="38" height="36" viewBox="0 0 38 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.747338">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M33.9896 24C33.9896 25.65 32.6323 27 30.9734 27H37.0058V30H0.811523V27H6.8439C5.185 27 3.82771 25.65 3.82771 24V9C3.82771 7.35 5.185 6 6.8439 6H30.9734C32.6323 6 33.9896 7.35 33.9896 9V24ZM30.9734 9H6.8439V24H30.9734V9Z"
                        fill="black" />
                </g>
              </svg>`
    } else if (name.includes('android')) {
        return `<svg width="38" height="36" viewBox="0 0 38 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.747338">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M24.9406 1.5H12.8758C10.3724 1.5 8.35156 3.51 8.35156 6V30C8.35156 32.49 10.3724 34.5 12.8758 34.5H24.9406C27.444 34.5 29.4649 32.49 29.4649 30V6C29.4649 3.51 27.444 1.5 24.9406 1.5ZM26.4487 27H11.3678V6H26.4487V27ZM15.892 31.5H21.9244V30H15.892V31.5Z"
                        fill="black" />
                </g>
              </svg>`
    } else if (name.includes('ios')) {
        return `<svg width="38" height="36" viewBox="0 0 38 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.747338">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M24.9406 1.5H12.8758C10.3724 1.5 8.35156 3.51 8.35156 6V30C8.35156 32.49 10.3724 34.5 12.8758 34.5H24.9406C27.444 34.5 29.4649 32.49 29.4649 30V6C29.4649 3.51 27.444 1.5 24.9406 1.5ZM26.4487 27H11.3678V6H26.4487V27ZM15.892 31.5H21.9244V30H15.892V31.5Z"
                        fill="black" />
                </g>
              </svg>`
    }
}

const formatDateFromNow = (date) => {
    if (!date) {
        return ''
    }

    const time = moment(date)
        .fromNow(true)

    return time + ' ago'
}

const formatCents = (value) => {
    const amount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    }).format(value/100)

    return amount.replace('$', '')
}

const formatDollars = (value) => {
    const amount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    }).format(value)

    return amount.replace('$', '')
}

export {
    formatOS, iconOS, formatCents, formatDollars, formatDateFromNow
}
